<template>
  <div class="tw-flex tw-content-center tw-gap-1">
    <template v-if="column.usesClassification">
      <template v-if="column.classification?.overridesAnother">
        <WdsTooltip
          :text="classificationOverridenTooltipText"
          :global="tableGlobals"
        >
          <DeterminationOverrideLogo size="16" />
        </WdsTooltip>
      </template>
      <template v-else>
        <WdsTooltip :text="$t('Using Worksome Classify')" :global="tableGlobals">
          <DeterminationLogo truncated size="16" />
        </WdsTooltip>
      </template>
    </template>
    <template v-else>
      <span>-</span>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsTooltip } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import DeterminationLogo from '@/components/compliances/Determinations/DeterminationLogo.vue'
import DeterminationOverrideLogo from '@/components/compliances/Determinations/DeterminationOverrideLogo.vue'
import { useTableGlobalsSelector } from '@/components/GraphqlDataTable/injection'

const tableGlobals = useTableGlobalsSelector()

const HireClassificationColumn = graphql(`
  fragment HireClassificationColumn on Hire {
    usesClassification
    classification {
      id
      overridesAnother
      overrideReason
      overrideUser {
        name
      }
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof HireClassificationColumn>
}>()

const column = computed(() => useFragment(HireClassificationColumn, props.row))

const classificationOverridenTooltipText = computed(() =>
  $t('The original classification was overridden by :user for the following reason: :reason', {
    user: column.value.classification?.overrideUser?.name,
    reason: column.value.classification?.overrideReason,
  }),
)
</script>
